import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import 'bootstrap-icons/font/bootstrap-icons.css';
import apiServices from '../services/service.js';
import { fetchDataAndUpdateStore } from '../redux/actions.js';
import Loader from '../shared/component/Loader.jsx';
import { updateUserDetail } from '../redux/reducer.js';
import { useAppAuth } from '../auth/appAuthContext.js';

export const SelectionPage = (props) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.data?.user?.user);
  const loading = useSelector((state) => state.loading?.user);
  const { user: accountDetail } = useAppAuth();

  useEffect(() => {
    const addUserActivity = () => {
      if (user) {
        const data = {
          userId: user.userId,
          lastLoginDateTime: null,
          lastLogoutDateTime: null,
          lastActivityDateTime: null,
          // lastActivityModule: null,
          // lastActionType: null,
          // lastActivityDetail: null,
          lastActivityModule: "Login",
          lastActionType: "View",
          lastActivityDetail: "Login into the CRM"
        };
        apiServices
          .addUserActivity(data)
          .then((response) => {
            if (response.status === 200) {
              const userData = {
                userId: user.userId,
                pageNumber: 1,
                pageSize: 50
              };
              apiServices
                .getUserActivity(userData)
                .then((response) => {
                  if (response.status === 200) {
                    // localStorage.setItem("userActivity", JSON.stringify(response.data.userActivities));
                    dispatch(
                      updateUserDetail({
                        userActivity: response.data.userActivities,
                      })
                    );
                  }
                })
                .catch((error) => {
                  console.error('Error:', error);
                });
            } else {
              const errorMessages = [];
              for (const key in response.errors) {
                if (response.errors.hasOwnProperty(key)) {
                  const messages = response.errors[key];
                  errorMessages.push(...messages);
                }
              }
              errorMessages.forEach((errorMessage) => {
                // toast.error(errorMessage, { position: "top-right" });
              });
            }
          })
          .catch((error) => {
            if (error.response && error.response.data && error.response.data.errors) {
              const errors = error.response.data.errors;
              const status = error.response.status;

              Object.keys(errors).forEach((errorType) => {
                const errorMessages = errors[errorType];
                errorMessages.forEach((errorMessage) => { });
              });
            }
          });
      }
    };

    addUserActivity(); // Call addUserActivity when user changes
  }, [user]); // Dependency array to watch for changes in user

  // useEffect(() => {
  //   if (accountDetail) {
  //     localStorage.removeItem('userUIControlPermission');
  //     dispatch(
  //       fetchDataAndUpdateStore({
  //         key: 'user',
  //         inputData: [
  //           accountDetail.idTokenClaims.preferred_username,
  //           accountDetail.idTokenClaims.oid,
  //         ],
  //       })
  //     );
  //   }
  // }, []);



  useEffect(() => {
    if (!accountDetail) return;
    localStorage.removeItem("userUIControlPermission");
    let inputData = null;
    // 🟦 MSAL user
    if (accountDetail?.type === "azure") {
      inputData = [accountDetail.username, accountDetail.oid];
    }
    // 🟩 DB user
    else if (accountDetail?.type === "db") {
      inputData = [accountDetail?.username];
    }

    if (inputData) {
      dispatch(
        fetchDataAndUpdateStore({
          key: "user",
          inputData,
        })
      );
    }
  }, []);




  useEffect(() => {
    if (user) {
      props.userDetail(user);
    }
  }, [user]);

  /**
   * Most applications will need to conditionally render certain components based on whether a user is signed in or not.
   * msal-react provides 2 easy ways to do this. AuthenticatedTemplate and UnauthenticatedTemplate components will
   * only render their children if a user is authenticated or unauthenticated, respectively.
   */
  return (
    <>
      {loading && <Loader />}
      {props.children}
    </>
  );
};
